<template>
  <div class="pingan-trunk-insurance">
    <!-- 工具栏 -->
    <div class="toolbar-container">
      <div class="search-section">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="投保人">
            <el-input 
              v-model="searchForm.policyholder" 
              placeholder="投保人" 
              style="width: 200px;"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item label="被保险人">
            <el-input 
              v-model="searchForm.beneficiary" 
              placeholder="被保险人" 
              style="width: 200px;"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item label="手机号">
            <el-input 
              v-model="searchForm.mobile" 
              placeholder="手机号码" 
              style="width: 140px;"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item label="保单号">
            <el-input 
              v-model="searchForm.policyNo" 
              placeholder="保单号" 
              style="width: 200px;"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item label="运单号">
            <el-input 
              v-model="searchForm.trackNo" 
              placeholder="运单号" 
              style="width: 200px;"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item label="车牌号">
            <el-input 
              v-model="searchForm.carNo" 
              placeholder="车牌号" 
              style="width: 140px;"
              maxlength="50"
            ></el-input>
          </el-form-item>

          <el-form-item label="投保时间">
            <span>开始时间：</span>
            <el-date-picker
              v-model="searchForm.beginTime"
              type="date"
              placeholder="开始时间"
              style="width: 110px;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <span style="margin-left: 10px;">结束时间：</span>
            <el-date-picker
              v-model="searchForm.endTime"
              type="date"
              placeholder="结束时间"
              style="width: 110px;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="投保状态">
            <el-select v-model="searchForm.status" style="width: 100px;" placeholder="投保状态">
              <el-option label="已支付" value="4"></el-option>
              <el-option label="已过期" value="8"></el-option>
              <el-option label="理赔中" value="16"></el-option>
              <el-option label="理赔完成" value="32"></el-option>
              <el-option label="未支付" value="1"></el-option>
              <el-option label="已取消" value="2"></el-option>
              <el-option label="已退保" value="64"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付方式">
            <el-select v-model="searchForm.payType" style="width: 100px;" placeholder="支付方式">
              <el-option label="余额支付" value="1"></el-option>
              <el-option label="睿保对接的微信支付" value="2"></el-option>
              <el-option label="鼎盛支付" value="4"></el-option>
              <el-option label="鼎盛余额支付" value="32"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="投保类型">
            <el-select v-model="searchForm.insureType" style="width: 100px;" placeholder="投保类型">
              <el-option label="客户投保" value="1"></el-option>
              <el-option label="代客投保" value="2"></el-option>
              <el-option label="线下投保" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="鼎盛回调">
            <el-select v-model="searchForm.callback" style="width: 100px;" placeholder="鼎盛回调">
              <el-option label="成功" value="true"></el-option>
              <el-option label="失败" value="false"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="生效时间">
            <span>生效时间：</span>
            <el-date-picker
              v-model="searchForm.effectedTime"
              type="date"
              placeholder="生效时间"
              style="width: 110px;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <span style="margin-left: 10px;">失效时间：</span>
            <el-date-picker
              v-model="searchForm.expiredTime"
              type="date"
              placeholder="失效时间"
              style="width: 110px;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="公里数">
            <span>开始距离:</span>
            <el-input 
              v-model="searchForm.beginDistance" 
              style="width: 100px; margin-left: 4px;"
            ></el-input>
            <span style="margin-left: 10px;">结束距离:</span>
            <el-input 
              v-model="searchForm.endDistance" 
              style="width: 100px; margin-left: 4px;"
            ></el-input>
          </el-form-item>

          <el-form-item label="渠道商:">
            <el-autocomplete
              v-model="searchForm.channel_id"
              :fetch-suggestions="queryChannel"
              placeholder="渠道商"
              clearable
              style="width: 200px;"
              @select="handleChannelSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.realname }} {{ item.alias ? '(' + item.alias + ')' : '' }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleShowAll">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="action-section">
        <div class="statistics">
          <strong>保费总额：<span style="color:#ff7300">{{ totalAmount }}</span>元</strong>
        </div>
        <div class="action-buttons">
          <el-button type="success" icon="el-icon-message" @click="sendYesterdayEmail">
            补发昨日订单申报邮件
          </el-button>
          <el-button type="primary" icon="el-icon-download" @click="exportExcel">
            导出Excel
          </el-button>
        </div>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="table-container">
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%"
        border
        stripe
        size="small"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="policyholder" label="投保人" width="170" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="beneficiary" label="被保险人" width="170" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="100" align="center"></el-table-column>
        <el-table-column prop="channel_name" label="渠道" width="160" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.channel_name">
              {{ scope.row.channel_name }} ({{ scope.row.alias }})
            </span>
            <span v-else>{{ scope.row.alias }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="policy_no" label="保单号" width="180" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.policy_no" 
                  style="color:green;cursor:pointer" 
                  @click="viewDetail(scope.row.id)">
              保单详情
            </span>
            <span v-else 
                  style="color:green;cursor:pointer" 
                  @click="viewDetail(scope.row.id)">
              {{ scope.row.policy_no }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="来源" width="150" align="center">
          <template slot-scope="scope">
            {{ formatSource(scope.row.source) }}
          </template>
        </el-table-column>
        <el-table-column prop="coverage" label="保额" width="80" align="center">
          <template slot-scope="scope">
            {{ formatCoverage(scope.row.coverage) }}
          </template>
        </el-table-column>
        <el-table-column prop="plate_no" label="车牌号" width="160" align="center"></el-table-column>
        <el-table-column prop="plate_extra_no" label="挂车牌号" width="160" align="center"></el-table-column>
        <el-table-column label="运输路线" width="300" align="center">
          <template slot-scope="scope">
            {{ formatHaulway(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="distance" label="距离" width="80" align="center">
          <template slot-scope="scope">
            {{ formatDistance(scope.row.distance) }}
          </template>
        </el-table-column>
        <el-table-column prop="carriage" label="运费" width="70" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.carriage) }}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="原价" width="70" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.price) }}
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="折扣" width="70" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.discount) }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_price" label="实付" width="70" align="center">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.pay_price) }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_type" label="支付方式" width="140" align="center">
          <template slot-scope="scope">
            {{ formatPayType(scope.row.pay_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="insure_type" label="投保类型" width="140" align="center">
          <template slot-scope="scope">
            {{ formatInsureType(scope.row.insure_type) }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="投保时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="保单状态" width="70" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)" size="mini">
              {{ formatStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" width="300" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="effected_at" label="生效时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.effected_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="expired_at" label="结束时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.expired_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="seq_no" label="序号" width="220" align="center"></el-table-column>
        <el-table-column prop="policy_notify_success" label="保单信息回传" width="140" align="center">
          <template slot-scope="scope">
            {{ formatPolicyNotify(scope.row.policy_notify_success) }}
          </template>
        </el-table-column>
        <el-table-column prop="callback_success" label="鼎盛是否成功回调" width="140" align="center">
          <template slot-scope="scope">
            {{ formatCallback(scope.row.callback_success) }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="viewDetail(scope.row.id)">详情</el-button>
            <el-button size="mini" type="text" @click="editOrder(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" style="color: #f56c6c;" @click="deleteOrder(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getPingAnTrunkInsuranceList, getPingAnTrunkInsuranceSum, exportPingAnTrunkInsuranceExcel, sendYesterdayOrderEmail } from '@/api/gxborder'
import { getChannelList } from '@/api/member'
import { Message } from 'element-ui'
import * as XLSX from 'xlsx'

export default {
  name: 'PingAnTrunkInsurance',
  data() {
    return {
      searchForm: {
        policyholder: '',
        beneficiary: '',
        mobile: '',
        policyNo: '',
        trackNo: '',
        carNo: '',
        beginTime: '',
        endTime: '',
        status: '',
        payType: '',
        insureType: '',
        callback: '',
        effectedTime: '',
        expiredTime: '',
        beginDistance: '',
        endDistance: '',
        channel_id: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      totalAmount: 0,
      channelList: [],
      selectedChannel: null
    }
  },
  mounted() {
    this.fetchData()
    this.fetchChannelList()
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      
      try {
        // 构建查询参数
        const listParams = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          ...this.buildSearchParams()
        }

        const sumParams = {
          ...this.buildSearchParams()
        }

        // 并行获取列表数据和总金额
        const [listResponse, sumResponse] = await Promise.all([
          getPingAnTrunkInsuranceList(listParams),
          getPingAnTrunkInsuranceSum(sumParams)
        ])
        
        if (listResponse && listResponse.rows) {
          this.tableData = listResponse.rows
          this.pagination.total = listResponse.total || 0
        } else {
          this.tableData = []
          this.pagination.total = 0
        }

        if (sumResponse && sumResponse.sum !== undefined) {
          this.totalAmount = (sumResponse.sum / 100).toFixed(2)
        } else {
          this.totalAmount = '0.00'
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        Message.error('获取数据失败，请稍后重试')
        this.tableData = []
        this.pagination.total = 0
        this.totalAmount = '0.00'
      } finally {
        this.loading = false
      }
    },

    // 构建搜索参数
    buildSearchParams() {
      const params = {}
      if (this.searchForm.policyholder) params.policyholder = this.searchForm.policyholder
      if (this.searchForm.beneficiary) params.beneficiary = this.searchForm.beneficiary
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile
      if (this.searchForm.policyNo) params.policy_no = this.searchForm.policyNo
      if (this.searchForm.trackNo) params.track_no = this.searchForm.trackNo
      if (this.searchForm.carNo) params.car_no = this.searchForm.carNo
      if (this.searchForm.beginTime) params.begin_date = Date.parse(new Date(this.searchForm.beginTime + " 00:00:00").toISOString()) / 1000
      if (this.searchForm.endTime) params.end_date = Date.parse(new Date(this.searchForm.endTime + " 23:59:59").toISOString()) / 1000
      if (this.searchForm.status) params.status = this.searchForm.status
      if (this.searchForm.payType) params.pay_type = this.searchForm.payType
      if (this.searchForm.insureType) params.insure_type = this.searchForm.insureType
      if (this.searchForm.callback !== '') params.callback_success = this.searchForm.callback
      if (this.searchForm.effectedTime) params.effected_at = Date.parse(new Date(this.searchForm.effectedTime + " 00:00:00").toISOString()) / 1000
      if (this.searchForm.expiredTime) params.expired_at = Date.parse(new Date(this.searchForm.expiredTime + " 23:59:59").toISOString()) / 1000
      if (this.searchForm.beginDistance) params.begin_distance = this.searchForm.beginDistance
      if (this.searchForm.endDistance) params.end_distance = this.searchForm.endDistance

      // 渠道搜索使用选中渠道的ID
      if (this.selectedChannel && this.selectedChannel.id) {
        params.channel_id = this.selectedChannel.id
      }

      return params
    },

    // 计算保费总额
    calculateTotalAmount() {
      return this.tableData.reduce((total, item) => {
        return total + (item.pay_price || 0) / 100
      }, 0).toFixed(2)
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 显示全部
    handleShowAll() {
      this.searchForm = {
        policyholder: '',
        beneficiary: '',
        mobile: '',
        policyNo: '',
        trackNo: '',
        carNo: '',
        beginTime: '',
        endTime: '',
        status: '',
        payType: '',
        insureType: '',
        callback: '',
        effectedTime: '',
        expiredTime: '',
        beginDistance: '',
        endDistance: '',
        channel_id: ''
      }
      this.selectedChannel = null
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },

    // 查看详情
    viewDetail(id) {
      this.$message.info(`查看保单详情: ${id}`)
      // 这里可以打开详情弹窗或跳转到详情页面
    },

    // 编辑订单
    editOrder(row) {
      this.$message.info(`编辑订单: ${row.policy_no || row.id}`)
      // 这里可以打开编辑弹窗
    },

    // 删除订单
    deleteOrder(row) {
      this.$confirm('确定要删除这个订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchData()
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 导出Excel
    async exportExcel() {
      try {
        this.loading = true
        
        // 构建查询参数（导出所有符合条件的数据）
        const params = {
          ...this.buildSearchParams()
        }

        const response = await exportPingAnTrunkInsuranceExcel(params)
        
        if (response && response.rows && response.rows.length > 0) {
          // 处理导出数据
          const exportData = response.rows.map(row => ({
            '投保人': row.policyholder || '',
            '被保险人': row.beneficiary || '',
            '手机号': row.mobile || '',
            '渠道': row.channel_name ? `${row.channel_name}(${row.alias})` : (row.alias || ''),
            '保单号': row.policy_no || '',
            '来源': this.formatSource(row.source),
            '保额': this.formatCoverage(row.coverage),
            '车牌号': row.plate_no || '',
            '挂车牌号': row.plate_extra_no || '',
            '运输路径': this.formatHaulway(row),
            '距离': this.formatDistance(row.distance),
            '运费（元）': this.formatMoney(row.carriage),
            '原价（元）': this.formatMoney(row.price),
            '折扣（元）': this.formatMoney(row.discount),
            '实付（元）': this.formatMoney(row.pay_price),
            '支付方式': this.formatPayType(row.pay_type),
            '投保时间': this.formatDate(row.created_at),
            '保单状态': this.formatStatus(row.status),
            '备注': row.note || '',
            '生效时间': this.formatDate(row.effected_at),
            '结束时间': this.formatDate(row.expired_at)
          }))

          // 使用json2Excel导出
          this.downloadExcel(exportData, '平安干线保订单')
          Message.success('Excel导出成功')
        } else {
          Message.warning('没有数据可导出')
        }
      } catch (error) {
        console.error('导出Excel失败:', error)
        Message.error('导出Excel失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 下载Excel文件
    downloadExcel(data, fileName) {
      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      
      // 下载文件
      XLSX.writeFile(wb, `${fileName}.xlsx`)
    },

    // 发送昨日邮件
    async sendYesterdayEmail() {
      try {
        await this.$confirm('您确定要补发昨日订单申报邮件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        this.loading = true
        
        const response = await sendYesterdayOrderEmail()
        
        if (response && response.err_code === 0) {
          Message.success('修改成功')
          // 刷新数据表格
          this.fetchData()
        } else {
          Message.error(response.err_msg || '邮件发送失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('发送邮件失败:', error)
          Message.error('发送邮件失败，请稍后重试')
        }
      } finally {
        this.loading = false
      }
    },

    // 渠道搜索相关方法
    queryChannel(queryString, cb) {
      if (!queryString) {
        cb(this.channelList)
        return
      }
      
      const results = this.channelList.filter(channel => {
        const searchText = queryString.toLowerCase()
        return (channel.realname && channel.realname.toLowerCase().includes(searchText)) ||
               (channel.alias && channel.alias.toLowerCase().includes(searchText))
      })
      cb(results)
    },

    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (error) {
        console.error('获取渠道列表失败:', error)
      }
    },

    handleChannelSelect(item) {
      this.selectedChannel = item
      this.searchForm.channel_id = item.realname + (item.alias ? '(' + item.alias + ')' : '')
    },

    // 格式化函数 - 匹配老项目逻辑
    formatSource(source) {
      switch (source * 1) {
        case 0:
          return "未知来源"
        case 1:
          return "PC浏览器端投保"
        case 2:
          return "移动浏览器端投保"
        case 4:
          return "iOS端投保"
        case 8:
          return "安卓端投保"
        case 16:
          return "API投保"
        case 32:
          return "微信小程序"
        case 64:
          return "渠道管理后台"
        case 128:
          return "内部管理后台"
        case 256:
          return "移动浏览器端投保-代理人H5"
        case 512:
          return "移动浏览器端投保-代客投保"
        default:
          return "未知来源"
      }
    },

    formatCoverage(coverage) {
      return coverage ? (coverage / 10000) + '万' : ''
    },

    formatHaulway(row) {
      if (row.start_province && row.start_city && row.end_province && row.end_city) {
        return `${row.start_province}${row.start_city}-${row.end_province}${row.end_city}`
      }
      return ''
    },

    formatDistance(distance) {
      return distance ? distance + '公里' : ''
    },

    formatMoney(amount) {
      if (!amount) return '0.00'
      const s = amount / 100
      const n = 2
      const f = s < 0 ? "-" : ""
      const abs = parseFloat((Math.abs(s) + "").replace(/[^\d\.-]/g, "")).toFixed(n) + ""
      const l = abs.split(".")[0].split("").reverse()
      const r = abs.split(".")[1]
      let t = ""
      for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "")
      }
      return f + t.split("").reverse().join("") + "." + r
    },

    formatPayType(payType) {
      switch (payType * 1) {
        case 0:
          return '未知状态'
        case 1:
          return '余额支付'
        case 2:
          return '睿保对接的微信支付'
        case 4:
          return '鼎盛支付'
        case 8:
          return '保险公司支付链接'
        case 16:
          return '线下支付'
        case 32:
          return '鼎盛余额支付'
        case 64:
          return '中际支付'
        default:
          return '未知状态'
      }
    },

    formatInsureType(insureType) {
      const insureTypeMap = {
        '1': '客户投保',
        '2': '代客投保',
        '4': '线下投保'
      }
      return insureTypeMap[insureType] || ''
    },

    formatStatus(status) {
      switch (status * 1) {
        case 1:
          return '未支付'
        case 2:
          return '已取消'
        case 4:
          return '已支付'
        case 8:
          return '已过期'
        case 16:
          return '理赔中'
        case 32:
          return '理赔完成'
        case 64:
          return '已退保'
        default:
          return '未知'
      }
    },

    getStatusTagType(status) {
      const typeMap = {
        '1': 'warning',
        '2': 'info',
        '4': 'success',
        '8': 'danger',
        '16': 'warning',
        '32': 'success',
        '64': 'info'
      }
      return typeMap[status] || 'info'
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      if (date.getFullYear() === 1) return ''
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    formatPolicyNotify(success) {
      return success ? '成功' : '失败'
    },

    formatCallback(success) {
      return success ? '成功' : '失败'
    },

    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 1 ? 'warning-row' : ''
    }
  }
}
</script>

<style lang="less" scoped>
.pingan-trunk-insurance {
  padding: 20px;

  .toolbar-container {
    background: #fff;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);

    .search-section {
      margin-bottom: 15px;
      
      .search-form {
        .el-form-item {
          margin-bottom: 10px;
          margin-right: 15px;
        }
      }
    }

    .action-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 15px;
      border-top: 1px solid #ebeef5;

      .statistics {
        font-size: 16px;
      }

      .action-buttons {
        .el-button {
          margin-left: 10px;
        }
      }
    }
  }

  .table-container {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    overflow: hidden;
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}

// 表格样式
/deep/ .el-table {
  .warning-row {
    background: #fdf6ec;
  }

  .el-table__header {
    background-color: #f5f7fa;
  }

  .el-table__body {
    tr:hover > td {
      background-color: #f5f7fa !important;
    }
  }
}
</style>
